import PropTypes from 'prop-types';
export default PropTypes.shape({
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired
});